import React from 'react'
import Mainlayout from './Components/Layout/Mainlayout'
import './styles/variables.css';
const App = () => {
  return (
    <Mainlayout />
  )
}

export default App